module.exports = __webpack_public_path__ + "img/Preview-3.0d17fa47.png";